<template>
  <div class="bg-gray-50 p-3 rounded border border-gray-200">
    <label class="inline-flex items-center gap-2 text-xs font-medium text-gray-700">
      <input
        type="checkbox"
        :checked="enabled"
        @change="$emit('update:enabled', $event.target.checked)"
      />
      {{ label }}
    </label>

    <div v-if="enabled" class="mt-2">
      <label class="block text-xs font-medium text-gray-700 mb-1">
        Match threshold: {{ threshold }}%
      </label>
      <input
        type="range"
        :value="threshold"
        min="50"
        max="100"
        step="5"
        class="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
        @input="$emit('update:threshold', Number($event.target.value))"
      />
      <p class="text-xs text-gray-500 mt-1">
        Higher values require closer matches (recommended: 80-90%)
      </p>
    </div>
  </div>
</template>

<script>
// The fuzzy-matching checkbox + threshold slider. Before extraction this block
// was pasted five times across the three ImportConfig components.
export default {
  name: 'FuzzyMatchControl',
  props: {
    enabled: { type: Boolean, required: true },
    threshold: { type: Number, required: true },
    label: { type: String, default: 'Enable fuzzy matching' },
  },
  emits: ['update:enabled', 'update:threshold'],
};
</script>
